export const throwErrorAsync = (error: Error): void => {
  setTimeout(() => {
    throw error;
  }, 0);
};
